module.exports = __webpack_public_path__ + "img/palmar-beach.90eda418.jpg";